var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcLidClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2519 14.3652L25.1814 12.4305C22.7254 7.44232 19.5835 4.90972 15.0002 4.06774C20.2857 2.71368 26.4279 3.1448 30.8335 9.64752L34.6553 7.76574L31.4965 18.2382L21.2519 14.3652ZM3.99991 34.9999H39.9999L37.9999 41.9999H3.99991V34.9999ZM20.5587 21.0979C31.5294 19.1226 36.7476 22.3141 38.6095 23.9443L41.4347 23.4356C42.25 23.2889 43.03 23.8308 43.1768 24.6461C43.3236 25.4614 42.7816 26.2414 41.9663 26.3882L4.07099 33.2113C3.25568 33.3581 2.47573 32.8161 2.32893 32.0008C2.18213 31.1855 2.72407 30.4056 3.53939 30.2588L3.83815 30.205C5.27117 27.9814 9.58796 23.0732 20.5587 21.0979Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcLidClose);
export default __webpack_public_path__ + "static/media/mc_lid_close.a347bf58b52fd3b95d289f85c1df1fe0.svg";
export { ForwardRef as ReactComponent };